import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { LayoutComponent } from './layout.component';
import { RouterLink, RouterOutlet } from '@angular/router';
import { FooterComponent } from './components/footer/footer.component';
import { ButtonModule } from 'primeng/button';
import { BadgeModule } from 'primeng/badge';
import { MenuModule } from 'primeng/menu';
import { UiModule } from '@ui/ui.module';
import { DialogModule } from 'primeng/dialog';
import { MessageModule } from 'primeng/message';
import { LetDirective } from '@ngrx/component';
import { EmptyPipe } from '@shared/pipes/empty/empty.pipe';
import { SkeletonModule } from 'primeng/skeleton';
import { CurrencyPipe } from '@shared/pipes/currency/currency.pipe';
import { MiniCartComponent } from './components/mini-cart/mini-cart.component';
import { SearchBarComponent } from './components/search-bar/search-bar.component';
import { ShowContentDirective } from '@shared/directives/show-content.directive';
import { TranslocoDirective, TranslocoPipe } from '@jsverse/transloco';
import { TranslocoDatePipe } from '@jsverse/transloco-locale';
import { DateFormatPipe } from '@shared/pipes/date-format.pipe';
import { LogoComponent } from './components/logo/logo.component';
import { DialogAssistanceInSelectionComponent } from './components/dialogs/dialog-assistance-in-selection/dialog-assistance-in-selection.component';
import { SocialNetworkCardComponent } from './components/social-network-card/social-network-card.component';
import { ImageModule } from 'primeng/image';
import { DialogCloseDirective } from '@shared/directives/dialog-close.directive';
import { SelectModule } from 'primeng/select';
import { DataAttributeDirective } from '@shared/directives/data-attribute.directive';
import { PopoverModule } from 'primeng/popover';
import { Tooltip } from 'primeng/tooltip';
import { TabsModule } from 'primeng/tabs';
import { BrandContactsComponent } from './components/footer/components/brand-contacts/brand-contacts.component';
import { FooterMenuColumnComponent } from './components/footer/components/footer-menu-column/footer-menu-column.component';
import { FooterPaymentComponent } from './components/footer/components/footer-payment/footer-payment.component';
import { NavigationMobileMenuComponent } from './components/navigation-mobile-menu/navigation-mobile-menu.component';
import { ShowOnPlatformDirective } from '@shared/directives/show-on-platform.directive';
import { MobileChatBotComponent } from './components/mobile-chat-bot/mobile-chat-bot.component';
import { MobileMenuComponent } from './components/page-header/components/header-user-info/components/mobile-menu/mobile-menu.component';
import { FlagIconPathPipe } from './components/page-header/components/header-user-info/pipes/get-flag-icon-path.pipe';
import { UserAssistanceLinksComponent } from './components/page-header/components/header-user-info/components/user-assistance-links/user-assistance-links.component';
import { UserActionsComponent } from './components/page-header/components/header-user-info/components/user-actions/user-actions.component';
import { MobileMenuButtonComponent } from './components/page-header/components/header-user-info/components/mobile-menu-button/mobile-menu-button.component';
import { UserBalanceInfoComponent } from './components/page-header/components/header-user-info/components/user-balance-info/user-balance-info.component';
import { LanguageSelectorComponent } from './components/page-header/components/header-user-info/components/language-selector/language-selector.component';
import { InformationMenuComponent } from './components/page-header/components/information-menu/information-menu.component';
import { HeaderMenuComponent } from './components/page-header/components/header-menu/header-menu.component';
import { PageHeaderComponent } from './components/page-header/page-header.component';
import { ProfileInfoComponent } from './components/profile-info/profile-info.component';
import { TelPipe } from '@shared/pipes/tel/tel.pipe';
import { ShowOnPlatformNarrowDirective } from '@shared/directives/show-on-platform-narrow.directive';
import { StartingPriceBannerComponent } from './components/starting-price-banner/starting-price-banner.component';

@NgModule({
  declarations: [
    LayoutComponent,
    HeaderMenuComponent,
    FooterComponent,
    InformationMenuComponent,
    DialogAssistanceInSelectionComponent,
    SocialNetworkCardComponent,
  ],
  imports: [
    CommonModule,
    RouterOutlet,
    ButtonModule,
    BadgeModule,
    MenuModule,
    UiModule,
    DialogModule,
    MessageModule,
    NgOptimizedImage,
    PopoverModule,
    LetDirective,
    EmptyPipe,
    SkeletonModule,
    CurrencyPipe,
    MiniCartComponent,
    SearchBarComponent,
    MobileMenuComponent,
    ShowContentDirective,
    TranslocoDirective,
    TranslocoDatePipe,
    DateFormatPipe,
    TranslocoPipe,
    LogoComponent,
    SelectModule,
    FlagIconPathPipe,
    ImageModule,
    DialogCloseDirective,
    DataAttributeDirective,
    Tooltip,
    RouterLink,
    TabsModule,
    NavigationMobileMenuComponent,
    BrandContactsComponent,
    FooterMenuColumnComponent,
    FooterPaymentComponent,
    ShowOnPlatformDirective,
    UserAssistanceLinksComponent,
    UserBalanceInfoComponent,
    LanguageSelectorComponent,
    UserActionsComponent,
    MobileChatBotComponent,
    MobileMenuButtonComponent,
    PageHeaderComponent,
    ProfileInfoComponent,
    TelPipe,
    ShowOnPlatformNarrowDirective,
    StartingPriceBannerComponent,
  ],
})
export class LayoutModule {}
